import {
    DefaultButton,
    IconButton,
    Modal,
    PrimaryButton,
    mergeStyleSets,
    ContextualMenu,
    Checkbox,
    ChoiceGroup,
  } from "@fluentui/react";
  import $ from "jquery";
  import React, { useEffect, useState, useRef, useContext } from "react";
  import ModalCheckIcon from "../../../../components/SVGComponents/ModalCheckIcon";
  import RemoveFindingIcon from "../../../../components/SVGComponents/RemoveFindingIcon";
  import FindingComp from "./FindingComp";
  import AnnotationContext from "../../../../context/annotation/AnnotationContext";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import './modalStyles.css';
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import userContext from "../../../../context/users/UserContext";
import toastContext from "../../../../context/toast/ToastContext";
import { useTranslation } from "react-i18next";
import { TOAST_TYPE } from "../../../../constants/Constants";
import { iconButtonStyles, iconButtonStylesFunc } from "../../../../components/Modal/ModalHeader";
import themeContext from "../../../../context/theme/ThemeContext";
  
  const DynamicConfigureModal = (props) => {
    const modalRef = useRef(null);
    const { showToastv2 } =
    useContext(toastContext);

    const { getThemeColor,getAlterColor,themeName,getScrollBarStyleForTheme } = useContext(themeContext);

    const [t, i18n] = useTranslation();

    const [containerWidth,setContainerWidth] = useState(600);
    const [containerHeight,setContainerHeight] = useState("fit-content");
    const [refresh,setReresh] = useState(false);
    

    useEffect(() => {
        const modalElement = modalRef.current;
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
    
        const modalRect = modalElement.getBoundingClientRect();
        const modalWidth = modalRect.width;
        const modalHeight = modalRect.height;
        const modalTop = modalRect.top;
        const modalLeft = modalRect.left;
    
       // TODO: Compare modal dimensions and position with viewport dimensions
        const isModalOutsideViewport = leftShift + modalWidth < 0 ||
          leftShift+containerWidth > viewportWidth;
        if (isModalOutsideViewport) {
        // console.log("--- Modal Going Out of the screen ----");
        let extra = leftShift+containerWidth - viewportWidth;
        console.log(extra);
          setLeftShift(leftShift-extra);
        } else {
        //   console.log('Modal is within the viewport');
        }
      }, [containerWidth]);

    let annotation_bar_max_width = null;
    let gfExtraFields = ['selectBodypart', 'txtLocation'];
    var gf_location = "";
    var timer = null;
    var gf_bodyPart = "";
    let gfArr = [
        {value:'Ankle', text:'Ankle'},
        {value:'Arm', text:'Arm'},
        {value:'Clavicle', text:'Clavicle'},
        {value:'Elbow', text:'Elbow'},
        {value:'Femur', text:'Femur'},
        {value:'Foot', text:'Foot'},
        {value:'Forearm', text:'Forearm'},
        {value:'Hand', text:'Hand'},
        {value:'Hip', text:'Hip'},
        {value:'Humerus', text:'Humerus'},
        {value:'Knee', text:'Knee'},
        {value:'Leg', text:'Leg'},
        {value:'Pelvis', text:'Pelvis'},
        {value:'Radius and Ulna', text:'Radius and Ulna'},
        {value:'Shoulder', text:'Shoulder'},
        {value:'Thigh', text:'Thigh'},
        {value:'Tibia and Fibula', text:'Tibia and Fibula'},
        {value:'Wrist', text:'Wrist'}
        ];

    let $annotation_hidden_div = null;

    // hardcoded widths in pixels for the popup
    let option_popup_widths = {
        "foreign-body": 224,
        narrow: 450,
        //    "normal": 600
        //"wide":780
    };

    let locationVal = "";

    const {
        studyParentId
    } = useContext(studyviewerContext);

    const {
        enableReportRegenerate,
        setEnableReportRegenerate
    } = useContext(studyReportContext)

    const {
        getListOfGroups,
        getAnnotationData,
        annotationState,
        containsChecker,
        handleCheckTab,
        setAnnotationState,
        getMaxSuboptions,
        addedAnnotation,
        setAddedAnnotation,
        tabs,
        setTabs,
        activeTab,
        setActiveTab,
        checkTab,
        setCheckedTab,
        tabContent,
        setTabContent,
        handleChangeCheck,
        handleChangeRadioButton,
        handleAIPathologyEdit,
        getStudyAnnotation,
        groupSelectionStore,
        handleDefaultGroupAndOptionsSelectionsBeforeSubmit,
        annotationStateStore
      } = useContext(AnnotationContext);

    const {username} = useContext(userContext);

      const [store, setStore] = useState(groupSelectionStore);

    // let leftShift = (props.screenX);
    const [leftShift, setLeftShift] = useState(props.screenX);
    let topShift = (props.screenY)+30;
    const ref = useRef(null);

    const dragOptions = {
        moveMenuItemText: "Move",
        closeMenuItemText: "Close",
        menu: ContextualMenu,
        dragHandleSelector: ".ms-Modal-scrollableContent > div:first-child",
        // keepInBounds: true,
      };
    
      const contentStyles = {
        container:{
            width:containerWidth,
            border: "1px solid #bfbfbf"
            // height:'700px',
        },
        scrollableContent:{
            overflowY:'hidden'
        },
        body:{
            height:containerHeight,
            overflowX:'auto',
            background: getThemeColor("modal-body")
        },
        main: {
          maxWidth: "none",
          maxHeight:"none",
          boxShadow: "0px -4px 40px rgba(0, 0, 0, 0.67)",
          borderRadius: "10px 10px 10px 10px",
          position: "absolute",
          top: topShift,
          left: leftShift,
          transform: "translate(50%, 50%)",
          cursor: "initial",
        //   scrollableContent:{
        //     maxHeight:"70vh"
        //   }
        },     
      };

      const removeFromArray = (arr, item) => {
        if (arr !== undefined && arr.length > 0) {
          let index = arr.indexOf(item);
      
          if (index > -1) {
            arr.splice(index, 1);
          }
        }
      }

    useEffect(()=>{
        // console.log("Annotation State change");
        // console.log(annotationState);
    },[annotationState]);

    useEffect(()=>{
        if(props.id != null){
            // console.log("ID is ",props.id)
            setContainerWidthPathology(props.pathologyName);
            let $optionsPopupDiv = $(
                "<div style='width:100%' id ='optionsPopupForStudyAnnotation_" +
                props.id +
                "' class='optionsdetails'></div>"
            );
            setTimeout(()=>{
                if(!$("#optionsPopupForStudyAnnotation_"+props.id).length){
                    $("#tab-body").append($optionsPopupDiv);
                }
                showSettings(studyParentId,props.id,0,$optionsPopupDiv,props.pathologyName);
            },100)
        }
    },[props.id,refresh]);


let pathWidthArr = [
    {name:"Atelectasis",width:700},
    {name:"General Fracture",width:1050},
    {name:"Spine",width:1370},
    {name:"Fibrosis",width:760},
    {name:"Consolidation",width:760},
    {name:"Left Knee",width:800},
    {name:"Right Knee",width:800},
    {name:"Lumbar With Flexion and Extension",width:1380},
    {name:"Lumbar With Obliques",width:1380}
]
let pathHeightArr = [
    {name:"Foreign Body",height:"60vh"}
]

const setContainerWidthPathology = (name) => {
    //let flag = 
    pathWidthArr.map((ele,index)=>{
        if(ele.name == name){
            setContainerWidth(ele.width);
        }
    });
    pathHeightArr.map((ele,index)=>{
        if(ele.name == name){
            setContainerHeight(ele.height);
        }
    })
}

const showSettings = (studyId, annotationId, number, $popup, pathologyName) => {
        let state = annotationState.annotations_popup_state[annotationId];
        // console.log(studyId);
        // if the 'settings' div is already there then just display it.
        let $div = $("#setting_div_" + annotationId);
    
        if ($div.length === 0) {
            // create the 'div'
            $div = $("<div id='setting_div_" + annotationId + "'></div>");
            $popup.append($div);
        }
    
        // display the div after regenerating the content
        regeneratePopup(
            studyId,
            annotationId,
            number,
            $popup,
            $div,
            pathologyName,
            state
        );
        $div.show();
    
        // hide elements for the 'OPENING', 'ERROR' and 'DELETE' state.
        // if (state === POPUP_OPENING) {
        //     $("#opening_div_" + annotationId).hide();
        // } else if (state === POPUP_SHOWING_ERROR) {
        //     $("#error_div_" + annotationId).hide();
        // } else if (state === POPUP_SHOWING_DELETE) {
        //     $("#delete_div_" + annotationId).hide();
        // }
    
        // change the state
        //annotation_state.annotations_popup_state[annotationId] =
          //  POPUP_SHOWING_SETTINGS;
    } // end of 'showSettings'


    const regeneratePopup = (
        studyId,
        annotationId,
        number,
        $popup,
        $div,
        pathologyName,
        state
    ) => {
        // empty all the elements in the given div.
        $div.empty();
    
        // add a marker html element to prevent us from overwriting the
        // elements
        // we
        // added earlier
        storeDbId(annotationId, $div);
    
        let data = getAnnotationData(annotationId);
    
        // if the returned data does not have any options then we are good.
        if (data && data.group_numbers.length > 0) {
            // now, all the options are present as groups.
            // So, first, get all the groups and their names.
            let listOfGroups = getListOfGroups(data);
            
            // console.log("List of Groups");
            // console.log(listOfGroups)
    
            // simple tab for showing the group results.
            //
            // We don't need this 'div' with tabs if we have only one group.
            if (listOfGroups.length > 1) {
                let $tabDivForGroup = $("<div style='border-bottom:1px solid #3B3A39' class='annotation-groups'></div>");
                let $tableWithingTabDiv = $("<table ></table>");
                $tabDivForGroup.append($tableWithingTabDiv);
                let $tabRow = $("<tr class='border_bottom'></tr>");
                $tableWithingTabDiv.append($tabRow);
    
                $div.append($tabDivForGroup);
    
                // so now, use the above list to populate the above 'div'
                // with
                // 'group selection labels and checkboxes'
                let largestGroupSize = 0;
                for (let i = 0; i < listOfGroups.length; i++) {
                    let groupObj = listOfGroups[i];
                    if (groupObj.option_ids.length > largestGroupSize) {
                        largestGroupSize = groupObj.option_ids.length;
                    }
    
                    // for now, we will always display the first group when
                    // the
                    // tab
                    // is reopened irrespective of which group
                    // the user was viewing when he last closed the the
                    // popup.
                   // let backgroundColor = i === 0 ? "rgb(112 120 122)" : "#2e3132";
                   let backgroundColor = i === 0 ? getAlterColor("#707870","#0078D4") :getAlterColor("#2e3132","#bab9b8");

                    let $groupColumn = $(
                        '<td  id="group-td-checkbox-' +
                        annotationId +
                        "-" +
                        groupObj.groupNumber +
                        '" class="group-column-' +
                        annotationId +
                        ' group-column" style="padding:5px;cursor: pointer;border-radius: 10px 10px 0px 0px;background-color:' +
                        backgroundColor +
                        '"></td>'
                    );
                    $groupColumn.css("border-color", "#5F6769");
                    $tabRow.append($groupColumn);
    
                    // register a click event for simply displaying the
                    // contents
                    // of
                    // this group.
                    
                    $groupColumn.hover(
                        function() {
                            timer = setTimeout(function() {
                                handleGroupColumnClick(annotationId, groupObj, $groupColumn);
                            }, 400);
                        },
                        function() {
                            clearTimeout(timer);
                        }
                    );
                    // now, if we are not dealing with the default group,
                    // then
                    // display a checkbox for displaying or
                    // hiding additional groups.
                    if (groupObj.groupNumber !== 0) {
                        // the background color decides whether this
                        // checkbox is
                        // checked or not.
                        let backgroundColor = "white";
                        let isChecked = false;
    
                        let annotationGroupSelectionArr =
                            annotationState.group_selections[annotationId];
    
                        if (containsChecker(annotationGroupSelectionArr, groupObj.groupNumber)) {
                            backgroundColor = "rgb(0, 120, 212)";
                            isChecked = true;
                        }
    
                        // create a checkbox
                        let $checkboxDiv = $(
                            '<div  id="group-checkbox-' +
                            annotationId +
                            "-" +
                            groupObj.groupNumber +
                            '" class="fa fa-sharp fa-check group-checkbox-for-annotation-' +
                            annotationId +
                            ' "' +
                            ' name = "checkBoxRadio" type="checkbox" style="cursor: pointer;vertical-align: top; background-color: ' +
                            backgroundColor +
                            "; color:white;margin-top: 4px; margin-right:9px; margin-left:5px; padding: 1px; border-radius: 20%" +
                            '; display: inline-block;"></div>'
                        );
                        $checkboxDiv.data("checked", isChecked);
                        $groupColumn.append($checkboxDiv);
    
                        // now, register the click event on this checkbox
                        //----IMP -----
                        $checkboxDiv.click(function(event) {
                            event.stopPropagation();
                            handleGroupCheckboxClick(
                                annotationId,
                                groupObj,
                                $checkboxDiv,
                                $groupColumn,
                                annotationState.annotationVersionMap[annotationId]
                            );
                        });
                    }
    
                    // create a label for holding the group-name
                    let groupName =
                        groupObj.groupNumber === 0 ? "Default" : groupObj["name"];
                    let $groupNameLabel = $(
                        "<span style='font-size:16px;'>" + groupName + "</span>"
                    );
                    $groupColumn.append($groupNameLabel);
                } // end of 'for' over the list of 'groups'
    
                if (largestGroupSize > 5) {
                    //$popup.css('height','270px');
                }
            } // end of 'if'
    
            // depending on the width we be setting the popup type here.
            // Arrrr....
            let popuptype = "";
    
            // again, iterate over the list of groups and populate the
            // option
            // content.
            for (let i = 0; i < listOfGroups.length; i++) {
                let groupObj = listOfGroups[i];
    
                // this is the extra field added to give some additional information
                // about the pathology
                let groupComment = groupObj.comment;
                // for now, we will always display the first group when the
                // tab
                // is
                // reopened irrespective of which group
                // the user was viewing when he last closed the the popup.
                let hideOrDisplay = i === 0 ? "block" : "none";
    
                let $tabContentDiv = $(
                    '<div id="group-tabcontent-id-' +
                    annotationId +
                    "-" +
                    groupObj.groupNumber +
                    '" class="group-tabcontent-' +
                    annotationId +
                    '" style="display:' +
                    hideOrDisplay +
                    '"></div>'
                );
                $div.append($tabContentDiv);
    
                // add a table to the popup
                let $table = $(
                    "<table class='optionstable table' style= 'overflow-y: auto; width: 100%;'></table>"
                );
    
                $tabContentDiv.append($table);
                let $commentBox = $(groupComment);
                $commentBox.css("position","unset");
                $tabContentDiv.append($commentBox);
    
                let maxNumOfSubOptions = getMaxSuboptions(groupObj, groupObj.option_ids);
    
                for (let i = 0; i < groupObj.option_ids.length; i++) {
                    let optionObj =
                        groupObj.option_id_and_option_suboption_dto_map[
                        groupObj.option_ids[i]
                        ];
    
                    // create an object having the format
                    // [{name: "L", value: 1, is_selected:0}, { name: "R",
                    // value: 2,
                    // is_selected:1 }, {name: "O", value: 3, is_selected:0}]
                    let suboptionsDetails = [];
    
                    for (let j = 0; j < optionObj.suboption_ids.length; j++) {
                        let suboptionObj =
                            optionObj.suboption_id_and_suboption_details_map[
                            optionObj.suboption_ids[j]
                            ];
    
                        // extract the 'suboption_name' , 'suboption_id' and
                        // 'is_slected' values and create a new
                        // json object with them.
                        suboptionsDetails.push({
                            name: suboptionObj["name"],
                            value: suboptionObj["id"],
                            is_selected: suboptionObj["is_selected"],
                            tooltip: suboptionObj["tooltip"],
                            is_hidden : suboptionObj['is_hidden']
                        });
                    } // end of for over suboptions
    
                    // if the option has only one suboption and if the name
                    // of
                    // that
                    // suboption is the same as the
                    // group, then we don't need to display it because that
                    // is a
                    // special suboption which we use
                    // internally.
                    //
                    // However, we do need that suboptin to be checked, but
                    // we
                    // have
                    // logic that checks any unchecked
                    // suboptions of an option of the group to which that
                    // option
                    // belongs, is selected.
                    if (
                        suboptionsDetails.length === 1 &&
                        groupObj.name
                            .toLowerCase()
                            .indexOf(suboptionsDetails[0].name.toLowerCase()) !== -1
                    ) {
                        // console.log("Doing nothing for default option of a group ....");
                    } else {
                        // finally, add a row with for this options using
                        // the
                        // given
                        // suboptions.
                        let bgv_color =
                            optionObj.bgv_color !== " " ? optionObj.bgv_color : " ";
                        //----IMP -----
                        let returnedPopupType = addRowAndColumnWithRadioButtons(
                            $table,
                            annotationId,
                            optionObj["id"],
                            optionObj["name"],
                            optionObj["is_part_of_combination"],
                            suboptionsDetails,
                            maxNumOfSubOptions,
                            pathologyName,
                            groupObj,
                            bgv_color
                        );
    
                        if (popuptype === "") {
                            popuptype = returnedPopupType;
                        } else {
                            // no need to modify anything if 'foreign-body'
                            // has
                            // been
                            // set.
    
                            if (popuptype === "narrow") {
                                popuptype = returnedPopupType; // if it is
                                // 'narrow'
                                // anything will
                                // do
                                // because this
                                // the
                                // smallest
                                // value.
                            } else if (popuptype === "normal") {
                                if (returnedPopupType === "wide") {
                                    popuptype = returnedPopupType;
                                }
                            }
                        }
                    }
                } // end of 'for' over options
            } // end of 'for' over the list of groups.
    
            // if the 'pathology name' is 'foreign body', or if we have a
            // row
            // with
            // more than '3' options, then we need to
            // modify the width of the popup.
            $popup.width(option_popup_widths[popuptype] + "px");
        } else {
            let $rowAndOtherData = $(
                "<div class='row'><div class='col-md-3'>&nbsp;</div><div class='col-md-6' style='font-size:20px'>" +
                "No options" +
                "</div><div class='col-md-3'>&nbsp;</div></div>"
            );
    
            $div.append("<br/>");
            $div.append($rowAndOtherData);
        } // end of check for 'options' length
    } // end of 'regeneratePopup'

    const storeDbId = (id, $popup) => {
        let $span = $("<span style='display:none' class='pathology_db_id'>" + id + "</span>");
    
        $popup.append($span);
    } // end of 'storeDbId'

    const handleGroupColumnClick = (annotationId, groupObj, $groupColumn) => {
        // hide all the 'contents' of other groups.
        $(".group-tabcontent-" + annotationId).hide();
    
        // display the 'tab content div' for this group number
        $("#group-tabcontent-id-" + annotationId + "-" + groupObj.groupNumber).show();
        $(".group-column-" + annotationId).css("background-color", getAlterColor("#2e3132","#bab9b8"));
        $(".group-column-" + annotationId).css("border-color", "#2e3132");
        $groupColumn.css("background-color", getAlterColor("#707870","#0078D4"));
    } // end of 'handleGroupColumnClick'

const handleGroupCheckboxClick = (
        annotationId,
        groupObj,
        $checkboxDiv,
        $groupColumn,
        annotationVersion
    ) => {
        handleAIPathologyEdit(annotationId);
        // first display the contents of this 'div'.
        handleGroupColumnClick(annotationId, groupObj, $groupColumn);
        setEnableReportRegenerate(true);
        // find out if this checkbox 'checked' or 'unchecked'
        let isChecked = $checkboxDiv.data("checked");
    
        if (isChecked) {
            // if this is already checked, then uncheck it. Now, allow this
            // only:
            // - if the user has some other group selected.
            let groupSelectionsArr = annotationState.group_selections[annotationId];
            // if(groupSelectionArr.length >= 2)
            if (true) {
                // remove this group from the list of selected groups.
                removeFromArray(groupSelectionsArr, groupObj.groupNumber);
                setAnnotationState(() => {
                    const newVal = { ...annotationState };
                    newVal.group_selections[annotationId] = groupSelectionsArr;
                   // newVal.selections[annotationId] = {};
                    return newVal;
                  });
                // if this array is empty then remove it from the map
                if (groupSelectionsArr.length === 0) {
                    //delete annotationState.group_selections[annotationId];
                    setAnnotationState(() => {
                        const newVal = { ...annotationState };
                        // newVal.group_selections[annotationId] = [];
                        delete newVal.group_selections[annotationId];
                        return newVal;
                      });
                }
    
                // then, unselect the checkbox
                //
                // For this all we need to do is change the background
                // colour of
                // this checkbox to white and
                // change the 'data' attribute value to 'false'
                let backgroundColor = "white";
                let isChecked = false;
    
                $checkboxDiv.data("checked", isChecked);
                $checkboxDiv.css("background-color", backgroundColor);
    
                // get the map containing the list of selections for this
                // annotaiton
                // id
                let annotationSelectionObj = annotationState.selections[annotationId];
    
                // unselect all the options in the group
                for (let i = 0; i < groupObj.option_ids.length; i++) {
                    let optionId = groupObj.option_ids[i];
    
                    // remove details regarding this 'option id' from the
                    // chosen
                    // options
                    //delete annotationSelectionObj[optionId];
                    setAnnotationState(() => {
                        const newVal = { ...annotationState };
                        // newVal.selections[annotationId][optionId] = [];
                        delete newVal.selections[annotationId][optionId];
                        return newVal;
                      });
    
                    let optionObj =
                        groupObj.option_id_and_option_suboption_dto_map[optionId];
    
                    for (let j = 0; j < optionObj.suboption_ids.length; j++) {
                        let suboptionId = optionObj.suboption_ids[j];
    
                        let $radioBtnOrCheckBoxDiv = $("#suboption-id-" + suboptionId);
    
                        // just change the background color
                        $radioBtnOrCheckBoxDiv.css("background-color", "white");
                        $radioBtnOrCheckBoxDiv.data("checked", false);
                    }
                }
            } // if the check if 2 or more options have been selected
        } else {
            // the checkbox is 'unchecked' here.
            //
            // So, we need to 'check' it
    
            // first add this group to list of selected groups.
            let groupSelectionsArr = annotationState.group_selections[annotationId];
            let tempAnnotationState = annotationState.group_selections;
            if (groupSelectionsArr === undefined || groupSelectionsArr === null) {
                groupSelectionsArr = [];
                //annotationState.group_selections[annotationId] = groupSelectionsArr;
                tempAnnotationState[annotationId] = groupSelectionsArr;
            }
    
            if(!groupSelectionsArr.includes(groupObj.groupNumber)){
                groupSelectionsArr.push(groupObj.groupNumber);
              }

              setAnnotationState(() => {
                const newVal = { ...annotationState };
                newVal.group_selections = tempAnnotationState;
                return newVal;
              });    
            // then, select the checkbox
            //
            // For this all we need to do is change the background colour of
            // this
            // checkbox to yellow and
            // change the 'data' attribute value to 'true'
            let backgroundColor = "rgb(0, 120, 212)";
            let isChecked = true;
    
            $checkboxDiv.data("checked", isChecked);
            $checkboxDiv.css("background-color", backgroundColor);
        } // end of 'if-else' on 'is-checked'
    } // end of 'handleGroupCheckboxClick'


const addRowAndColumnWithRadioButtons = (
        $table,
        annotationId,
        optionId,
        optionName,
        isOptionPartOfCombination,
        suboptionsJson,
        maxNumberOfSuboptions,
        pathologyName,
        groupObj,
        bgv_color
    ) => {

        let rowName = optionName;
        // replace the spaces in 'optionName' with '&nbsp'
        optionName = optionName.replace(/ /g, "&nbsp;");
        // console.log("Annotation Id "+annotationId);
        // console.log(annotationState);
        // get the selections for this 'option' id. We will need them for
        // checking
        // or unchecking an option.
        let optionSelections = annotationState.selections[annotationId];
        let extraValue = annotationState.extra_value;
    
        if (optionSelections === undefined) {
            optionSelections = {};
        }
    
        var for_bgv_color = groupObj["option_id_and_option_suboption_dto_map"];
    
        let padding =
            pathologyName === "Foreign Body"
                ? "10px 10px 10px 25px"
                : "5px 5px 5px 15px";
    
        let $row = $("<tr class='border_bottom'></tr>");
    
        // if condition that checks if the row css is present , if
        // present
        // apply it else go with the default.
    
        $row.css("background-color", bgv_color);
    
        $table.append($row);
    
        // first column
        // also calculate its width
        // $annotation_hidden_div.append(optionName);
        // let totalWidth = $annotation_hidden_div.width();
        // $annotation_hidden_div.empty();
    
        if (pathologyName === "General Fracture") {
           
            var $optionNameColumn = $(
                '<td class= "general-fracture-' +
                groupObj.groupNumber +
                "\"style='padding: " +
                padding +
                "' title= " +
                optionName +
                "></td>"
            );
        } else {
            var $optionNameColumn = $(
                "<td style='padding: " + padding + "' title= " + optionName + "></td>"
            );
        }
    
        $optionNameColumn.append(optionName);
    
        $row.append($optionNameColumn);
    
        if (pathologyName === "General Fracture") {
            var $column =
                suboptionsJson.length > 1
                    ? suboptionsJson.length % 2 === 0
                        ? $('<td colspan="5"></td>')
                        : $('<td colspan="4"></td>')
                    : $('<td colspan="2"></td>');
            $row.append($column);
        }
    
        for (let i = 0; i < suboptionsJson.length; i++) {
            let suboptionObj = suboptionsJson[i];
            let suboptionName = suboptionObj["name"].replace(/ /g, "&nbsp;");
    
            // now, if this we are dealing with 'Foreign Body' then we need
            // to
            // add
            // an extra column with only checkboxes
            // for selecting or un-selecting an option.
            // We need to do this only for the first option
            if (pathologyName === "Foreign Body" && i === 0) {
                // we need to add another column in this case
                let $foreignBodyColumn = $("<td></td>");
                $row.append($foreignBodyColumn);
    
                // if this is a 'foreign body' then we will have only one
                // suboption.
                // Use it to find out where we need to
                // display a checked or unchecked checkbox.
                let checkedString =
                    optionSelections[optionId] !== undefined &&
                        optionSelections[optionId] !== null &&
                        optionSelections[optionId].length > 0
                        ? "checked"
                        : "";
    
                let $label = $("<label class='options-checkbox-container'></label>");
                $foreignBodyColumn.append($label);
    
                let $checkbox = $(
                    '<input id="options-input-checkbox-' +
                    optionId +
                    "\" type='checkbox' class='foreign_body_checkbox' name='" +
                    optionName +
                    "' value='" +
                    suboptionObj["value"] +
                    "' " +
                    checkedString +
                    ">"
                );
                $label.append($checkbox);
    
                let $span = $(
                    '<span class="options-checbox-checkmark" style="cursor: pointer;"></span>'
                );
                $label.append($span);
    
                $checkbox.change(function(event) {
                    event.stopPropagation();
                    if ($(this).is(":checked")) {
                        // checking it is like selecting the first
                        // suboption.
                        //
                        // This is the first suboption itself. So, we are
                        // good.
                        let $theDiv = $("#suboption-id-" + suboptionObj["value"]);
    
                        // perform the same action as clicking on the above
                        // radio
                        // button div.
                        onSelectOptionClick(
                            annotationId,
                            optionId,
                            suboptionObj["value"],
                            1,
                            isOptionPartOfCombination,
                /* clicked div */ $theDiv,
                            groupObj
                        );
                    } else {
                        let $theDiv = $("#suboption-id-" + suboptionObj["value"]);
    
                        // first find out if we can allow this
                        if ($(".foreign_body_checkbox:checkbox:checked").length === 0) {
                            $(this).prop("checked", true);
                        } else {
                            onSelectOptionClick(
                                annotationId,
                                optionId,
                                suboptionObj["value"],
                                0,
                                isOptionPartOfCombination,
                  /* clicked div */ $theDiv,
                                groupObj
                            );
                        }
                    }
                });
            } // end of 'if' check for 'foreign key'
    
            if (pathologyName === "General Fracture") {
                var $spacingDiv = $('<span class="span-suboptionslist"></span>');
                $column.append($spacingDiv);
            } else {
                // i + 2 th column
                var $column = $("<td></td>");
                $row.append($column);
            }
    
            // NOW, if this suboption, is selected, then the 'background'
            // color
            // should be 'yellow', otherwise
            // it should be white.
            // Similarly, store the 'data-selected' value.
            let backgroundColor = "";
            let dataSelected = null;
            // console.log("Checking");
            // console.log(suboptionObj["value"]);
            // console.log(optionSelections[optionId])
            if (containsChecker(optionSelections[optionId], parseInt(suboptionObj["value"]))) {
                // console.log("Chaning color");
                backgroundColor = "rgb(0, 120, 212)";
                dataSelected = true;
            } else {
                backgroundColor = "white";
                dataSelected = false;
            }
    
            let $radioButtonDiv = null;
    
            if (isOptionPartOfCombination === 1) {
                if (pathologyName !== "General Fracture") {
                    $radioButtonDiv = $(
                        '<div  id="suboption-id-' +
                        suboptionObj["value"] +
                        '" class="fa fa-check suboption-for-option-' +
                        optionId +
                        ' "' +
                        'name="checkBoxRadio" style="cursor: pointer;vertical-align: top; background-color: ' +
                        backgroundColor +
                        "; color:white;margin-top: 4px; margin-right:9px; margin-left:5px; padding: 1px; border-radius: 20%" +
                        '; display: inline-block;"></div>'
                    );
                } else {
                    $radioButtonDiv = $(
                        '<div  id="suboption-id-' +
                        suboptionObj["value"] +
                        '" class="fa fa-check  suboption-for-option-' +
                        optionId +
                        ' "' +
                        'name="checkBoxRadio" title ="' +
                        optionName +
                        " " +
                        suboptionName +
                        '" style=" cursor: pointer;vertical-align: top; background-color: ' +
                        backgroundColor +
                        "; color:white;margin-top: 4px; margin-right:9px; margin-left:5px; padding: 1px; border-radius: 20%" +
                        '; display: inline-block;"></div>'
                    );
                }
            } else if (isOptionPartOfCombination === 2) {
                /*
                      $radioButtonDiv = $("<div  id=\"suboption-id-" + suboptionObj['value'] + "\" class=\"fa fa-check suboption-for-option-" + optionId + " \"" +
                              "name=\"checkBoxRadio\" style=\"cursor: pointer;vertical-align: top; background-color: " + backgroundColor 
                              + "; color:white; margin-right:9px; margin-left:5px; padding: 1px; border-radius: 20%" +
                              "; display: inline-block;\"></div>");*/
                var vt =
                    extraValue["general-fracture"] != undefined &&
                        extraValue["general-fracture"]["txtLocation"] != undefined
                        ? extraValue["general-fracture"]["txtLocation"]
                        : undefined;
                var tv = "";
                if (vt) {
                    tv = vt[0];
                }
                if (gf_location != "") {
                    tv = gf_location;
                }
                if (locationVal !== "") {
                    tv = locationVal;
                    gf_location = tv;
                }
                // console.log("TV is");
                // console.log(tv);
    
                $radioButtonDiv = $(
                    '<div  id="suboption-id-' +
                    suboptionObj["value"] +
                    '" class="suboption-for-option-' +
                    optionId +
                    ' "' +
                    'name="inputBox" style="cursor: pointer;vertical-align: top; background-color: ' +
                    backgroundColor +
                    ";" +
                    '; display: inline-block;">' +
                    '<input type="text" id="txtLocation" onblur="gf_location=this.value" size="40" value="' +
                    tv +
                    '"> ' +
                    "</div>"
                );
                 
                getLocationTextValue();
                
                
            } else if (isOptionPartOfCombination === 3) {
                /*
                      $radioButtonDiv = $("<div  id=\"suboption-id-" + suboptionObj['value'] + "\" class=\"fa fa-check suboption-for-option-" + optionId + " \"" +
                              "name=\"checkBoxRadio\" style=\"cursor: pointer;vertical-align: top; background-color: " + backgroundColor 
                              + "; color:white; margin-right:9px; margin-left:5px; padding: 1px; border-radius: 20%" +
                              "; display: inline-block;\"></div>");*/
                $radioButtonDiv = $(
                    '<div  id="suboption-id-' +
                    suboptionObj["value"] +
                    '" class="suboption-for-option-' +
                    optionId +
                    ' "' +
                    'name="inputSelect" style="cursor: pointer;vertical-align: top; background-color: ' +
                    backgroundColor +
                    ";" +
                    '; display: inline-block;"></div>'
                );
                var select = $("<select>");
                select.attr("id", "selectBodypart");
    
                $(gfArr).each(function() {
                    select.append($("<option>").attr("value", this.val).text(this.text));
                });
                select.appendTo($radioButtonDiv);
    
                var vt =
                    extraValue["general-fracture"] != undefined &&
                        extraValue["general-fracture"]["selectBodypart"] != undefined
                        ? extraValue["general-fracture"]["selectBodypart"]
                        : undefined;
                if (vt) {
                    select.val(vt[0]);
                }

                getBodyPartTextValue();
            } else {
                if (pathologyName === "General Fracture") {
                    $radioButtonDiv = $(
                        '<div  id="suboption-id-' +
                        suboptionObj["value"] +
                        '" class="circle-for-annotation suboption-for-option-' +
                        optionId +
                        ' "' +
                        ' name="checkBoxRadio" title ="' +
                        suboptionName +
                        '" style="cursor: pointer;vertical-align: top; background-color: ' +
                        backgroundColor +
                        "; margin-right:18px; margin-left:5px; border-radius: 50%" +
                        '; display: inline-block;"></div>'
                    );
                } else {
                    $radioButtonDiv = $(
                        '<div  id="suboption-id-' +
                        suboptionObj["value"] +
                        '" class=" circle-for-annotation suboption-for-option-' +
                        optionId +
                        ' "' +
                        ' name="checkBoxRadio" style="cursor: pointer;vertical-align: top; background-color: ' +
                        backgroundColor +
                        "; margin-right:18px; margin-left:5px; border-radius: 50%" +
                        '; display: inline-block;"></div>'
                    );
                }
            }
    
            $radioButtonDiv.data("checked", dataSelected);
    
            if (pathologyName === "General Fracture") {
                $spacingDiv.append($radioButtonDiv);
            } else {
                $column.append($radioButtonDiv);
            }
    
            let $span = $("<span>" + suboptionName + "</span>");
            $span.attr("title", suboptionObj["tooltip"]);
            if (pathologyName === "General Fracture") {
                groupObj.groupNumber !== 9
                    ? $spacingDiv.append($span)
                    : $spacingDiv.append("<span>&nbsp;</span>");
            } else {
                $column.append($span);
            }
    
            $radioButtonDiv.click(function(event) {
                event.stopPropagation();
                // now, if this is a 'foreign body' popup, then we need to
                // select
                // the 'option id' checkbox if it is
                // unselected.
                if (pathologyName === "Foreign Body") {
                    let $theSuperCheckbox = $("#options-input-checkbox-" + optionId);
    
                    if ($theSuperCheckbox.prop("checked") === false) {
                        $theSuperCheckbox.prop("checked", true);
                    }
                }
    
                onSelectOptionClick(
                    annotationId,
                    optionId,
                    suboptionObj["value"],
                    1,
                    isOptionPartOfCombination,
            /* clicked div */ $radioButtonDiv,
                    groupObj
                );
            
             });
    
            // VERY IMPORTANT
            // If the suboption is not for the 'ICD, Pacemakers and
            // Catheters'
            // option, then simply hide the above
            // radio button because we don't need to display it
            if (pathologyName === "Foreign Body" && (suboptionsJson.length === 1 || suboptionsJson[i]['is_hidden'] === 1)) {
                $radioButtonDiv.hide();
                $span.hide();
            }
        } // end of for
    
        // add empty cells to keep the number of columns consistent for this
        // table
        let remainingColumns = maxNumberOfSuboptions - suboptionsJson.length;
        // this is great
        for (let j = 0; j < remainingColumns; j++) {
            let $column = $("<td>&nbsp;</td>");
            $row.append($column);
        }
    
        // append the content of this div to the hidden div and calculate
        // its
        // width
        // $annotation_hidden_div.append($row.clone());
        // totalWidth = $annotation_hidden_div.width();
        // $annotation_hidden_div.empty();
    
        //console.log("Total width for '" + optionName + "': " + totalWidth);
    
        // if we have a width above 230px then we need to use a extra wide
        // popup.
        // var popuptype = "";
    
        // if (totalWidth < 230) {
        //     popuptype = "narrow";
        // } else if (totalWidth < 350) {
        //     popuptype = "normal";
        // } else {
        //     popuptype = "wide";
        // }
    
        return "normal";
    } // end of 'addRowAndColumnWithRadioButtons'

const onSelectOptionClick = (
        studyAnnotationId,
        optionId,
        suboptionId,
        shouldAdd,
        isOptionPartOfCombination,
        $radioBtnDiv,
        groupObj
    ) => {
        //onSelectOptionClick
        //when any option or suboptions are modified then highlight regen button
        //highlightRegenerateButton();
        handleAIPathologyEdit(studyAnnotationId);
        setEnableReportRegenerate(true);
        let studyAnnotationOptionSelections = null;
        // console.log("Inside onSelect");
    
        if (annotationState.selections.hasOwnProperty(studyAnnotationId)) {
            // console.log("Inside If");
            studyAnnotationOptionSelections =
                annotationState.selections[studyAnnotationId];
        } else {
            studyAnnotationOptionSelections = {};
            // console.log("Inside Else");
            setAnnotationState(() => {
                const newVal = { ...annotationState };
               // newVal.group_selections[annotationId] = groupSelectionsArr;
                newVal.selections[studyAnnotationId] =  studyAnnotationOptionSelections;
                return newVal;
              });

           // annotationState.selections[studyAnnotationId] =
              //  studyAnnotationOptionSelections;
        }
    
        if (shouldAdd === 1) {
            // console.log("Inside 2nd If 1");
            let listOfSuboptions = studyAnnotationOptionSelections[optionId];
    
            // if a list of suboptions for storing the options is not
            // already
            // present, then add one.
            if (listOfSuboptions === undefined || listOfSuboptions === null) {
                listOfSuboptions = [];
                studyAnnotationOptionSelections[optionId] = listOfSuboptions;
            }
    
            let isChecked = $radioBtnDiv.data("checked");
    
            if (isChecked) {
                // console.log("Inside 3nd If 1");
                if (isOptionPartOfCombination) {
                    // if this is a part of a combination, then clicking on
                    // the
                    // element should remove it.
                    if (true) {
                        // so, search for this 'suboption id' and remove it.
                        let elementIndex = getElementIndex(listOfSuboptions, suboptionId);
                        listOfSuboptions.splice(elementIndex, 1);
    
                        // change the background colour
                        $radioBtnDiv.css("background-color", "white");
    
                        // store this unchecked value
                        $radioBtnDiv.data("checked", false);
                    }
                }
    
                // if this is not a part of a combination, then clicking on
                // an
                // already checked annotation should not
                // result in anything. Do Nothing in that case.
            } else {
                // console.log("Inside 3nd ELSE 1");
                if (isOptionPartOfCombination) {
                    // console.log("Inside 4nd IF 1");
                    // if this is part of a combination, then add this
                    // 'suboption'
                    // to the list of options which have
                    // already been added.
                    listOfSuboptions.push(suboptionId);
    
                    // change the background colour
                    $radioBtnDiv.css("background-color", "rgb(0, 120, 212)");
    
                    // store this checked value
                    $radioBtnDiv.data("checked", true);
                } else {
                    // console.log("Inside 3nd ELSE 1");
                    // if this is not a part of a combination, then remove
                    // all
                    // the
                    // earlier suboptions and add this
                    // one.
                    listOfSuboptions.length = 0;
                    listOfSuboptions.push(suboptionId);
    
                    // mark the option options as unselected
                    $(".suboption-for-option-" + optionId).css("background-color", "white");
    
                    // mark this radiobutton as selected
                    $radioBtnDiv.css("background-color", "rgb(0, 120, 212)");
    
                    // remove the 'data' attribute for the other radio
                    // buttons.
                    $(".suboption-for-option-" + optionId).data("checked", false);
    
                    // add the 'data' attribute for this radio buttons
                    $radioBtnDiv.data("checked", true);
                }
    
                // also, add this group the list of selected groups, if it
                // is
                // not
                // already present
                let selectedGroups = annotationState.group_selections[studyAnnotationId];
    
                if (selectedGroups === undefined || selectedGroups === null) {
                    selectedGroups = [];

                    setAnnotationState(() => {
                        const newVal = { ...annotationState };
                        newVal.group_selections[studyAnnotationId] = selectedGroups;
                        return newVal;
                      });

                    //annotationState.group_selections[studyAnnotationId] = selectedGroups;
                }
    
                if (!containsChecker(selectedGroups, groupObj.groupNumber)) {
                    selectedGroups.push(groupObj.groupNumber);
                }

                setAnnotationState(() => {
                    const newVal = { ...annotationState };
                    newVal.group_selections[studyAnnotationId] = selectedGroups;
                    return newVal;
                  });
    
                // now, select the checbox for this group and annotation.
                let $groupCheckbox = $(
                    "#group-checkbox-" + studyAnnotationId + "-" + groupObj.groupNumber
                );
                $groupCheckbox.css("background-color", "rgb(0, 120, 212)");
                $groupCheckbox.data("checked", true);
            } // end of if-else
        } else {
            //studyAnnotationOptionSelections =
            //annotationState.selections[studyAnnotationId];
            let tempStudyAnnotationOption = annotationState.selections[studyAnnotationId];
            let tempGroupAnnotationOption = annotationState.group_selections[studyAnnotationId];

            let obj1 = tempStudyAnnotationOption;
            let newObj1 = Object.keys(obj1)
            .filter(key => key != optionId)
            .reduce((acc, key) => {
                acc[key] = obj1[key];
                return acc;
            }, {});

            setAnnotationState(()=>{
                const newItem = {...annotationState};
                newItem.selections[studyAnnotationId] = newObj1;
                return newItem;
            })

            //delete studyAnnotationOptionSelections[optionId];
    
            // after deleting, if the 'studyAnnotationOptionSelections' is
            // empty,
            // then delete it as well.
            if ($.isEmptyObject(studyAnnotationOptionSelections)) {

                let obj1 = tempStudyAnnotationOption;
                let obj2 = tempGroupAnnotationOption;
                let newObj1 = Object.keys(obj1)
                .filter(key => key != optionId)
                .reduce((acc, key) => {
                    acc[key] = obj1[key];
                    return acc;
                }, {});
    
                let newObj2 = Object.keys(obj2)
                .filter(key => key != studyAnnotationId)
                .reduce((acc, key) => {
                    acc[key] = obj2[key];
                    return acc;
                }, {});

                //delete annotationState.selections[studyAnnotationId];
    
                // if there are no selections, then there is no need to keep
                // the
                // groups as well.
                //delete annotationState.group_selections[studyAnnotationId];

                setAnnotationState(()=>{
                    const newItem = {...annotationState};
                    newItem.selections = newObj1;
                    newItem.group_selections = newObj2;
                    return newItem;
                })
            }
    
            // remove the selections on all the options as well and mark all
            // the
            // options as 'checked - false'.
            $(".suboption-for-option-" + optionId).css("background-color", "white");
            $(".suboption-for-option-" + optionId).data("checked", false);
        }
    } // end of 'onSelectOptionClick'


    const resetFunction = (e, annotationId) => {
        if(e != null){
            e.stopPropagation();
            e.preventDefault();
        }
        
        //highlightRegenerateButton();
        setEnableReportRegenerate(true);
        
        
        // console.log("---- Annotation State Store ---", annotationStateStore, " ");

        // console.log("---- Annotation State ---", annotationState, " ");

        let groupSelection = [];
        
        if(annotationStateStore.group_selections[annotationId]?.length > 0){
            annotationStateStore.group_selections[annotationId]?.map((ele)=>{
                groupSelection.push(ele);
            })
        }
        let selectionArr = {};

        if (annotationStateStore.selections[annotationId]) {
          const nestedObj = annotationStateStore.selections[annotationId];
        
          Object.keys(nestedObj).forEach((key) => {
            const value = nestedObj[key][0];
            selectionArr[key] = [value];
          });
        }
        
        // console.log("Group Select",selectionArr);

        const storeObjGroupSelection = annotationStateStore.group_selections[annotationId];
        
        const ids = annotationId;
        const newState = {...annotationState, group_selections: {...annotationState.group_selections, [ids]: groupSelection},
        selections: {...annotationState.selections, [ids]: selectionArr}
    };
        // console.log(newState);
        setAnnotationState(newState);

        let annotationTemp = addedAnnotation?.map((ele,index)=>{
            if(ele.id == annotationId){
              return ele;
            }
          })
          showToastv2(TOAST_TYPE.SUCCESS, t("string-literals.default-state-reset"));
        setTimeout(()=>{

            let updatedAddedAnnotation = addedAnnotation?.map((ele,index)=>{
                if(ele.id == annotationId){
                  ele.isAIEdited = false;
                }
                return ele;
              })
              setAddedAnnotation(updatedAddedAnnotation);

            setReresh((prev)=>!prev);
        },300);
        // console.log("---- Resetting annotation ---",annotationTemp);
        //getStudyAnnotation(true);
        // this is the list of selected 'option ids' for this annotation
        // let selections = annotationState.selections[annotationId];
        // let tempAnnotationState = annotationState.group_selections;
    
        // // iterate over all the annotation data and get the object for this annotation
        // let annotationData = null;
        // annotationState.annotations_stuff.forEach((annotationObject) => {
        //     if (annotationObject.id === annotationId) {
        //         annotationData = annotationObject;
        //     }
        // });
    
        // if (annotationId === 54) {
        //     $("#txtLocation").val(" ");
        //     locationVal = "";
        //     gf_location = "";
        //     setAnnotationState(()=>{
        //         const newVal = {...annotationState};
        //         if(newVal.extra_value["general-fracture"] == undefined){
        //             newVal.extra_value["general-fracture"] = {};
        //         }
        //         if(newVal.extra_value["general-fracture"]["selectBodypart"] == undefined){
        //             newVal.extra_value["general-fracture"]["selectBodypart"] = [];
        //         }else{
        //             newVal.extra_value["general-fracture"]["selectBodypart"][0] = [];
        //         }
        //         if(newVal.extra_value["general-fracture"]["txtLocation"] == undefined){
        //             newVal.extra_value["general-fracture"]["txtLocation"] = [];
        //         }else{
        //             newVal.extra_value["general-fracture"]["txtLocation"][0] = [];
        //         }
                
        //         return newVal;
        //     })
        // }
    
        // // first, let us unselect the group checkboxes
        // let selectedGroupsArr = [...annotationState.group_selections[annotationId]];
    
        // // now, simulate a 'click' on each group radio-box
        // selectedGroupsArr.forEach((groupNumber) => {
        //     let $groupCheckbox = $(
        //         "#group-checkbox-" + annotationId + "-" + groupNumber
        //     );
    
        //     if ($groupCheckbox !== undefined && $groupCheckbox !== null) {
        //         $groupCheckbox.click();
        //     }
    
        //     // now, let us handle un-selecting the 'options' for this 'group'
    
        //     // now iterate over all the values in 'annotation_stuff' and get the 'option id and suboption ids map' for
        //     // this group.
        //     let groupData =
        //         annotationData.group_number_and_group_option_dto_map[groupNumber];
    
        //     for (let [optionId, optionsData] of Object.entries(
        //         groupData.option_id_and_option_suboption_dto_map
        //     )) {
        //         // now, if we are dealing with 'Foreign Body' annotations then we need to uncheck the option-checkbox as
        //         // well
    
        //         // We will simply check for the existence of such a control and uncheck it if we find it
        //         let $optionInputCheckbox = $("#options-input-checkbox-" + optionId);
    
        //         if ($optionInputCheckbox !== undefined && $optionInputCheckbox !== null) {
        //             $optionInputCheckbox.prop("checked", false);
        //         }
    
        //         // now, uncheck the sub-options
        //         for (let suboptionId in optionsData.suboption_id_and_suboption_details_map) {
        //             let $suboptionCheckbox = $("#suboption-id-" + suboptionId);
    
        //             $suboptionCheckbox.css("background-color", "white");
        //             $suboptionCheckbox.data("checked", false);
        //         }
    
        //         // now, remove this option from the list of 'selections'
        //         let selectionArr = selections[optionId];
        //         if (selectionArr !== undefined) {
        //             selectionArr.length = 0;
        //         }
        //     } //end of 'for' over the options
        // });

        // let obj = tempAnnotationState;
        // let newObj = Object.keys(obj)
        // .filter(key => key != annotationId)
        // .reduce((acc, key) => {
        //     acc[key] = obj[key];
        //     return acc;
        // }, {});
        // setAnnotationState(()=>{
        //     const newItem = {...annotationState};
        //     newItem.selections[annotationId] = {};
        //     newItem.group_selections = newObj;
        //     return newItem;
        // });
       
        
    } //end of 'resetFunction'

    const getElementIndex = (list, element) => {
        let foundIndex = null;
    
        for (let i = 0; i < list.length; i++) {
            if (list[i] === element) {
                foundIndex = i;
            }
        }
    
        return foundIndex;
    } // end of 'getElementIndex'

    const getLocationTextValue = () => {
        // console.log("Updating");
        $(document).ready(function() {
            $("#txtLocation").blur(function() {
                setAnnotationState(()=>{
                    const newVal = {...annotationState};

                    if(newVal.extra_value["general-fracture"] == undefined){
                        newVal.extra_value["general-fracture"] = {};
                    }
                    if(newVal.extra_value["general-fracture"]["txtLocation"] == undefined){
                        newVal.extra_value["general-fracture"]["txtLocation"] = [];
                        newVal.extra_value["general-fracture"]["txtLocation"].push($(this).val());
                    }else{
                        newVal.extra_value["general-fracture"]["txtLocation"][0] = $(this).val();
                    }
                    return newVal;
                })
                locationVal = $(this).val();
                $(this).val($(this).val());
            });
        });
    }

    const getBodyPartTextValue = () => {
        $(document).ready(function() {
            $("#selectBodypart").on("change", function() {
                setAnnotationState(()=>{
                    const newVal = {...annotationState};
                    if(newVal.extra_value["general-fracture"] == undefined){
                        newVal.extra_value["general-fracture"] = {};
                    }
                    if(newVal.extra_value["general-fracture"]["selectBodypart"] == undefined){
                        newVal.extra_value["general-fracture"]["selectBodypart"] = [];
                        newVal.extra_value["general-fracture"]["selectBodypart"].push($(this).val());
                    }else{
                        newVal.extra_value["general-fracture"]["selectBodypart"][0] = $(this).val();
                    }
                    
                    return newVal;
                })
            });
        });
    }


  
    return (
      <>
        <div>
          <Modal
            ref={modalRef}
            className="configure-modal"
            titleAriaId="id"
            dragOptions={dragOptions}
            isOpen={props.showConfigureModal}
            containerClassName={contentStyles.container}
            styles={contentStyles}
          >
            <div className="modal-container">
              <div className="modal-container-header" style={{background:getThemeColor("modal-header-footer")}}>
                <span style={{color: getThemeColor("primary-color")}} className="modal-header-heading-updated">{props.pathologyName}</span>
                 <IconButton
                styles={iconButtonStylesFunc(getThemeColor)}
                iconProps = {{iconName: 'Cancel'}}
                ariaLabel="Close popup modal"
                onClick={props.handleCloseModal}
                ref={ref}
                className='modal-header-crossicon-button'
                />
              </div>
            </div>
            <div className={getScrollBarStyleForTheme(themeName,"common-modal-scroll")} style={contentStyles.body}>
              <div id="tab-body" style={{color:getThemeColor("primary-color"),colorScheme:`${themeName==='light'?'none':'inherit'}`}} className="tab-container-modal">
                 
              </div>
            </div>
            <div className="modal-container-footer" style={{background:getThemeColor("modal-header-footer"),}}>
              <div className="modal-footer-react">
                {/* <button onClick={props.handleCloseModal} className="reset-button">
                {t("button.done")}
                </button> */}
                <DefaultButton onClick={(e)=>{resetFunction(e,props.id)}} text={t("button.reset")} />
                <div className="button-end-container" style={{marginLeft: "10px"}}>
                  {/* <button onClick={(e)=>resetFunction(e,props.id)} className="reset-button">{t("button.reset")}</button> */}     
                  <PrimaryButton onClick={props.handleCloseModal} text={t("button.done")} />
                  {/* <button style={{marginLeft:'10px'}} className="completed-button">Completed</button> */}
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </>
    );
  };
  
  export default DynamicConfigureModal;
  